module.exports = "/_next/static/images/ea43c28584d31c1282f05ad97dab5dbf-image-left-lg.jpg";